var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke: #231f20;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: #7fcbb4;\n      }\n\n      .cls-5 {\n        fill: none;\n      }\n\n      .cls-3 {\n        fill: #fad1a2;\n      }\n\n      .cls-4 {\n        fill: #a8a5c6;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.21,21.95c-.22,1.4-.86,2.73-1.94,3.81l-.22,.22-4.79,4.79-4.79-4.79-.22-.22c-1.08-1.08-1.72-2.41-1.94-3.81-.18-1.11-.08-2.27,.3-3.34,.32-.96,.87-1.86,1.64-2.63l3.62-3.62,1.39-1.39,1.15,1.15,3.86,3.86c.67,.67,1.17,1.44,1.51,2.27,.49,1.18,.63,2.46,.43,3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.26,26.97c-1.72,0-3.35-.37-4.82-1.02l4.82,4.82,4.8-4.8c-1.47,.64-3.09,1-4.79,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.37,4.1c-1.55-.72-3.28-1.13-5.1-1.13s-3.56,.41-5.11,1.14l5.1,5.1,5.11-5.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.3,21.95c-.34-2.11,.31-4.34,1.94-5.97l2.72-2.72-.88-.88-3.9,3.9-4.49-4.49c-.28,1.01-.43,2.08-.43,3.18,0,4.91,2.95,9.12,7.17,10.98l-.19-.2c-1.08-1.07-1.72-2.41-1.94-3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.83,11.77l-4.51,4.51-3.9-3.9-.88,.88,2.72,2.72c1.63,1.63,2.28,3.86,1.94,5.97-.22,1.39-.86,2.73-1.94,3.8l-.21,.22c4.24-1.85,7.21-6.08,7.21-11,0-1.11-.15-2.18-.43-3.2Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 22.27,
    cy: 10.77,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 10.27,
    cy: 10.77,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M9.19,2.14L2.12,9.21l7.07,7.07,7.07-7.07L9.19,2.14Zm1.08,10.63c-1.11,0-2-.9-2-2s.89-2,2-2,2,.89,2,2-.9,2-2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M23.33,2.14l-7.07,7.07,7.07,7.07,7.07-7.07-7.07-7.07Zm-1.06,10.63c-1.11,0-2-.9-2-2s.89-2,2-2,2,.89,2,2-.9,2-2,2Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 14.02,
    y: 10.14,
    width: 4.48,
    height: 4.48,
    transform: "translate(-3.99 15.12) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    width: 32,
    height: 32.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    y: 0.28,
    width: 32,
    height: 32
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.55fac3dd3d51f9a960e0e5a2df8d2e87.svg";
export { ForwardRef as ReactComponent };